import React from 'react';
import { Quote } from 'lucide-react';

import './About.css';
import { theme } from '../../theme/designSystem';
import { aboutData } from '../../data/aboutData';

function About() {
    return (
        <section className="about section-pad" id="about" style={{ backgroundColor: theme.tertiary }}>
            <div className="container">
                <div className="about--header">
                    <span className="eyebrow eyebrow--center">About</span>
                    <h2 style={{ color: theme.primary }}>Beyond the systems</h2>
                </div>

                <div className="about--content">
                    <div className="about--narrative">
                        <p className="about--lead" style={{ color: theme.textPrimary }}>
                            {aboutData.description1}
                        </p>
                        <p style={{ color: theme.textSecondary }}>
                            {aboutData.description2}
                        </p>
                    </div>

                    <blockquote className="about--quote">
                        <Quote className="about--quote-icon" size={24} aria-hidden="true" />
                        <p style={{ color: theme.primary }}>{aboutData.quote}</p>
                    </blockquote>
                </div>
            </div>
        </section>
    );
}

export default About;
